import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import SendTo from 'scoreboard/components/send-to'
import SendToOptions from 'scoreboard/components/send-to-options'
import Tooltip from 'scoreboard/components/tooltip'
import PermissionsAuditExportHeader from './permissions-audit-export-header.hbs'


/**
 * Shared functionality between the different permissions audit views.
 */
var PermissionsAudit = Backbone.View.extend({

    events: {
    	'click .send-to': 'onClickSendTo'
    },

	// we're not ready for an export until we've fetched the data and the view
	// emits the 'ready' event
	deferredReady: true,

    onClickSendTo: function(e) {
        let target = $(e.currentTarget)

		const exportOptions = _.extend({
			includeScheduledCount: false
		}, this.domainObjectInfo())

        this.sendToTooltip = new Tooltip({
            attachTo: target,
            content: new SendTo({
                sendToOptions: [].concat(
                    SendToOptions.pdf(exportOptions)
                )
            }),
            placement: 'below',
            arrow: 'right',
            extraClass: 'has-bootslide-menu'
        }).render()
    },

	/**
	 * Returns the domainId and domainType for the domain object being audited.
	 * Should be implemented by the subclass.
	 * @abstract
	 */
	domainObjectInfo () {},

    /**
     * Updates the export header with the given selection title and page title.
     * This is hidden if it is not an export.
     */
    updateExportHeader: function({selectionTitle, pageTitle}) {
        let exportHeaderHtml = PermissionsAuditExportHeader({
            selectionTitle,
            pageTitle
        })
        this.$('.export-header').empty().html(exportHeaderHtml)
    },

    autoRemove: true

})

export default PermissionsAudit
PermissionsAudit.__filename__ = 'admin/permissions-audit.js'
